import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { couponsApiPath } from './apiPath';

const PostCouponReceiveRequestSchema = z
  .object({
    shopTitle: z.string(),
    couponNo: z.number().int(),
  })
  .describe('PostCouponReceiveRequest');

export type PostCouponReceiveRequest = z.infer<typeof PostCouponReceiveRequestSchema>;

const PostCouponReceiveDataSchema = z.object({
  couponNo: z.number().int(),
});

export const PostCouponReceiveResponseSchema = createApiResponseSchema(PostCouponReceiveDataSchema);
export type PostCouponReceiveResponse = z.infer<typeof PostCouponReceiveResponseSchema>;

export const postCouponReceive = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostCouponReceiveRequestSchema),
    async ({ shopTitle, couponNo }: PostCouponReceiveRequest): Promise<PostCouponReceiveResponse> =>
      executeStandardRequest(() =>
        privateHttpClient.post<PostCouponReceiveResponse>(
          couponsApiPath.postCouponReceive(couponNo),
          { shopTitle },
        ),
      ),
    validateApiResponse(PostCouponReceiveResponseSchema),
  ),
);
